/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { PaginaDocument, SoluzioneDocument, SoluzioniDocument, UltimeCollezioniDocument } from '@gql/graphql'
import { SoluzioniDetailTemplate } from '@components/templates'

const SoluzioneDetail = ({ pagina, soluzione, ultimeCollezioni }) => (
  <SoluzioniDetailTemplate soluzione={soluzione} pagina={pagina} collezioni={ultimeCollezioni} />
)

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { soluzioni },
  //   } = await client.query({
  //     query: SoluzioniDocument,
  //   })

  //   soluzioni?.forEach((x) => paths.push({ params: { slug: x.slug }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/soluzioni/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { soluzione },
    } = await client.query({
      query: SoluzioneDocument,
      variables: { slug, preview },
      context: {
        headers,
      },
    })

    const {
        data: { ultimeCollezioni },
      } = await client.query({
        query: UltimeCollezioniDocument,
        context: {
          headers,
        },
      })

    if (!soluzione) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        contentTypeId: soluzione.model,
        objectId: soluzione.pk,
        chiave: 'soluzione-detail',
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { soluzione, pagina, ultimeCollezioni },
      revalidate: 60 * 20,
    }
  },
  '/soluzioni/[slug]'
)

export default SoluzioneDetail
